import { createAction, props } from '@ngrx/store';

// Reducer types
import { IDevicesStateData, ISessionStateData, IWorkerStateData } from './session.reducer';

// Interfaces
import { ICaptions } from '@interfaces/call.interfaces';

// Session params
export const setSessionParams = createAction(
  '[Session] Set session params',
  props<{ session: ISessionStateData }>(),
);

// Captions from socket
export const setCaptionsStatusFromSocket = createAction(
  '[Session] Set captions status state from socket',
  props<{ data: ICaptions }>(),
);

// Toggle captions
export const toggleCaptionsStatus = createAction(
  '[Session] Toggle captions state',
  props<{ data: { captions: boolean; call_id: number | string } }>(),
);

export const toggleCaptionsSuccessStatus = createAction(
  '[Session] Toggle captions state success',
  props<{ captions: boolean }>(),
);

export const toggleCaptionsErrorStatus = createAction(
  '[Session] Toggle captions state error',
  props<{ error?: unknown }>(),
);

export const clearCaptionsStatusState = createAction('[Session] Clear captions state');

// Mirror / chat
export const toggleMirrorState = createAction(
  '[Session] Toggle mirror state',
  props<{ mirror?: boolean }>(),
);

export const toggleChatState = createAction('[Session] Toggle chat state');

// Devices
export const setDevicesState = createAction(
  '[Session] Set devices state',
  props<{ devices: IDevicesStateData }>(),
);

export const changeDevicesState = createAction(
  '[Session] Change devices state',
  props<{ devices: { audio?: boolean; video?: boolean } }>(),
);

// Notification message in chat
export const setNotificationMessageState = createAction(
  '[Session] Set notification message state',
  props<{ state: boolean }>(),
);

// Worker
export const setWorkerState = createAction(
  '[Session] Set worker state',
  props<{ worker: IWorkerStateData }>(),
);

export const clearWorkerState = createAction('[Session] Clear worker state');
